import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const actionCoOrder = createAsyncThunk('coOrders/actionCoOrder',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, `/co/orders/${id}/${type}`);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });
export const clearActionCoOrder = createAction('clearActionCoOrder');
export default actionCoOrder;
